import { BROADCAST_UPDATE_ATTENDEE_PRESENCE } from '../Types';
import { setAttendeePresence } from './index';

function updateAttendeePresence(attendeeId, present) {
  return dispatch => {
    const action = {
      type: BROADCAST_UPDATE_ATTENDEE_PRESENCE,
      payload: { attendeeId, present }
    };
    dispatch(action);
    dispatch(setAttendeePresence(attendeeId, present));
  };
}

export default updateAttendeePresence;
